import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SnackbarSeverity = "success" | "error" | "warning" | "info";

interface SnackbarState {
  status: boolean;
  message: string;
  severity?: SnackbarSeverity; // ✅ optional
}

interface AuthState {
  snackbarDetails: SnackbarState;
}

const initialState: AuthState = {
  snackbarDetails: {
    status: false,
    message: "",
    severity: "success",
  },
};

const AuthSliceReducer = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    setSnackbarDetails(
      state,
      action: PayloadAction<{
        status: boolean;
        message: string;
        severity?: SnackbarSeverity;
      }>,
    ) {
      state.snackbarDetails = {
        ...action.payload,
        severity: action.payload.severity || "success",
      };
    },
  },
});

export const { setSnackbarDetails } = AuthSliceReducer.actions;
export default AuthSliceReducer.reducer;
